import React, { useEffect, useState, Fragment } from 'react';
import { func, array } from 'prop-types';
import classNames from 'classnames/bind';

import { withErrorBoundary } from 'containers/ErrorBoundary';

import IconArrowDown from 'media/icons/arrow-down.icon.svg';
import styles from './SelectBrand.module.scss';
const cx = classNames.bind(styles);

const SelectBrand = ({ dataOeNumbers, setCurrentBrand }) => {
  const [brands, setBrands] = useState([]);

  const changeBrand = (event) => {
    setCurrentBrand(brands[event.target.value]);
  };

  // @todo: Refactor this function.
  const getBrands = () => {
    let brands = [];
    dataOeNumbers.forEach((element) => {
      const hasBrand = brands.filter(
        (item) => item.brandName === element.brandName
      ).length;

      if (!hasBrand) {
        brands.push({
          brandName: element.brandName,
          models: dataOeNumbers.filter(
            (item) => item.brandName === element.brandName
          ),
        });
      }
    });

    return brands;
  };

  useEffect(() => {
    const brands = getBrands();
    setBrands(brands);
    setCurrentBrand(brands[0]);
  }, []);

  return (
    <Fragment>
      {brands && (
        <div className={cx('select-container', 'oe-select')}>
          <span className={cx('arrow')}>
            <IconArrowDown className={cx('icon')} />
          </span>
          <select className={cx('select')} onChange={changeBrand}>
            {brands.map((item, index) => (
              <option key={index} value={index}>
                {item.brandName}
              </option>
            ))}
          </select>
        </div>
      )}
    </Fragment>
  );
};

SelectBrand.propTypes = {
  dataOeNumbers: array.isRequired,
  setCurrentBrand: func.isRequired,
};

export default withErrorBoundary(SelectBrand);



// WEBPACK FOOTER //
// ./src/pages/Product/components/SelectBrand/SelectBrand.js